import { globalStyObj } from '@/assets/packageAssets/allStyleConfigs/a-global-cfg.js'

import { echoStyObj } from '@/assets/packageAssets/allStyleConfigs/echo.cfg.js'
import { joychatStyObj } from '@/assets/packageAssets/allStyleConfigs/joychat.cfg.js'
import { kikoStyObj } from '@/assets/packageAssets/allStyleConfigs/kiko.cfg.js'
import { vavaStyObj } from '@/assets/packageAssets/allStyleConfigs/vava.cfg.js'
import { vibeoStyObj } from '@/assets/packageAssets/allStyleConfigs/vibeo.cfg.js'

// 包变量
const styObj = {
  echo: {
    // 样式资源
    ...echoStyObj,
    // 图片资源
    '--icon-time': `url(${require('@/assets/packageAssets/views/P1_Boys/MyProps/default/time.png')})`,
    '--icon-details': `url(${require('@/assets/packageAssets/views/P1_Boys/MyProps/default/details.png')})`,
  },
  joychat: {
    // 样式资源
    ...joychatStyObj,
    // 图片资源
    '--icon-time': `url(${require('@/assets/packageAssets/views/P1_Boys/MyProps/default/time.png')})`,
    '--icon-details': `url(${require('@/assets/packageAssets/views/P1_Boys/MyProps/default/details.png')})`,
  },
  kiko: {
    // 样式资源
    ...kikoStyObj,
    // 图片资源
    '--icon-time': `url(${require('@/assets/packageAssets/views/P1_Boys/MyProps/default/time.png')})`,
    '--icon-details': `url(${require('@/assets/packageAssets/views/P1_Boys/MyProps/default/details.png')})`,
  },
  vava: {
    // 样式资源
    ...vavaStyObj,
    // 图片资源
    '--icon-time': `url(${require('@/assets/packageAssets/views/P1_Boys/MyProps/default/time.png')})`,
    '--icon-details': `url(${require('@/assets/packageAssets/views/P1_Boys/MyProps/default/details.png')})`,
  },
  vibeo: {
    // 样式资源
    ...vibeoStyObj,
    // 图片资源
    '--icon-time': `url(${require('@/assets/packageAssets/views/P1_Boys/MyProps/default/time.png')})`,
    '--icon-details': `url(${require('@/assets/packageAssets/views/P1_Boys/MyProps/default/details.png')})`,
  },
}

export const pageCssVars = {
  methods: {
    cssVars () {
      if (this.packageName && styObj[this.packageName]) {
        // 全局 + 局部包
        return { ...globalStyObj, ...styObj[this.packageName] }
      }
      return {}
    }
  }
}
